export const API = {
  admin: {
    config: {
      update: (key: string, value: unknown) =>
        fetch(`/api/admin/settings/${key}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            value,
          }),
        }),
    },
  },
  mod: {
    announce: (title: string, body?: string) =>
      fetch("/api/mod/user/@all/notice", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title,
          body,
        }),
      }),
  },
  macro: {
    syncEventFromFEAPI: (event_id: string) =>
      fetch("https://api.fediverse.events/v1/events/" + event_id)
        .then((req) => {
          if (!req.ok)
            throw new Error(
              "fediverse.events api returned not ok " + req.status,
            );
          return req.json();
        })
        .then((eventData) =>
          API.admin.config.update("event.dates", {
            start: new Date(eventData.start).getTime(),
            end: new Date(eventData.end).getTime(),
          }),
        ),
  },
};

// @ts-expect-error global export
window.API = API;
